<script setup>
import { computed } from 'vue';
import { useFieldErrors } from '@/composables/ruleEngine/useFieldErrors';

const props = defineProps({
    modelValue: {
        type: Object,
        default: () => ({
            applicant_min_age: null,
            applicant_max_age: null,
            co_applicant_min_age: null,
            co_applicant_max_age: null,
        }),
    },
    errors: { type: [Array, Object], default: () => ({}) },
});

const emit = defineEmits(['update:modelValue']);

const model = computed({
    get: () => props.modelValue || {},
    set: (val) => emit('update:modelValue', val),
});

const { errorsFor } = useFieldErrors(props);

const setNumber = (key, value) => {
    emit('touched');
    let finalValue = null;

    if (value !== '' && value !== null) {
        finalValue = Number(value);
    }

    model.value = {
        ...model.value,
        [key]: finalValue,
    };
};

const applicantMinAge = computed({
    get: () => model.value.applicant_min_age ?? '',
    set: (val) => setNumber('applicant_min_age', val),
});

const applicantMaxAge = computed({
    get: () => model.value.applicant_max_age ?? '',
    set: (val) => setNumber('applicant_max_age', val),
});

const coApplicantMinAge = computed({
    get: () => model.value.co_applicant_min_age ?? '',
    set: (val) => setNumber('co_applicant_min_age', val),
});

const coApplicantMaxAge = computed({
    get: () => model.value.co_applicant_max_age ?? '',
    set: (val) => setNumber('co_applicant_max_age', val),
});
</script>

<template>
<div>
    <p class="font-semibold mb-3">
        {{ $t('label.age_limits_rule_title') }}
    </p>

    <div class="grid md:grid-cols-2 gap-4">
        <StyledInput
            v-model="applicantMinAge"
            :label="$t('label.applicant_min_age')"
            name="applicant_min_age"
            type="number"
            :error-messages="errorsFor('applicant_min_age')" />

        <StyledInput
            v-model="applicantMaxAge"
            :label="$t('label.applicant_max_age')"
            name="applicant_max_age"
            type="number"
            :error-messages="errorsFor('applicant_max_age')" />

        <StyledInput
            v-model="coApplicantMinAge"
            :label="$t('label.co_applicant_min_age')"
            name="co_applicant_min_age"
            type="number"
            :error-messages="errorsFor('co_applicant_min_age')" />

        <StyledInput
            v-model="coApplicantMaxAge"
            :label="$t('label.co_applicant_max_age')"
            name="co_applicant_max_age"
            type="number"
            :error-messages="errorsFor('co_applicant_max_age')" />
    </div>
</div>
</template>
